import { render, staticRenderFns } from "./Forget.vue?vue&type=template&id=4bf79c30"
import script from "@/controllers/ap/login/Forget?vue&type=script&lang=ts&external"
export * from "@/controllers/ap/login/Forget?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports